<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !exchangeRukuVisible">
      <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_BATCH_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batchCreate')"
          >
            批量创建
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <!-- <el-button
            v-permission="{pkey:`${permissionName}_BATCH_ADD`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batchDelete')"
          >
            批量删除
          </el-button> -->
        </div>
      </div>
      <div style="display:flex">
        <el-table
          v-loading="listLoading"
          :data="list"
          border
          row-key="id"
          style="width: 40%"
          :lazy="true"
          :load="handleLoadLazy"
          :highlight-current-row="true"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @selection-change="handleSelectionChange"
          @row-click="handlePositonTableClick"
          @header-dragend="handleHeaderDragend"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            v-for="(column, index) of columnData"
            :key="column.fieldKey + index"
            :prop="JSON.stringify(column)"
            :label="column.fieldName"
            :min-width="column.width || 100"
            show-overflow-tooltip
          >
            <template #default="{ row }" >
             <i v-if="row.deliveryConfirmed" class="icon-tubiao-40 iconfont"></i> <span>{{ row[column.fieldKey] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="t('table.actions')"
            align="center"
            width="200"
            class-name="fixed-width"
          >
            <template #default="{ row }">
              <el-link
                v-permission="{ pkey: `${permissionName}_ADD` }"
                href="javascript:void(0);"
                class="mr-10"
                type="primary"
                @click="handleCommand('addRow', row)"
              >
                {{ t("table.add") }}
              </el-link>
              <el-link
                  v-permission="{ pkey: `${permissionName}_EDIT` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('edit', row)"
              >
                  {{ t("table.edit") }}
              </el-link>
              <el-link
                href="javascript:void(0);"
                class="mr-10"
                type="primary"
                @click="handleCommand('rukuError', row)"
              >
               异常入库
              </el-link>
              <el-link
                  v-permission="{ pkey: `${permissionName}_DELETE` }"
                  href="javascript:void(0);"
                  type="danger"
                  @click="handleCommand('delete', row)"
              >
                  {{ t("table.delete") }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="materialData"
          style="flex:1"
          border
          :highlight-current-row="true"
          @header-dragend="handleMaterialHeaderDragend"
        >
          <el-table-column
            v-for="(column, index) of materialCloumn"
            :key="column.fieldKey + index"
            :prop="JSON.stringify(column)"
            :label="column.fieldName"
            :min-width="column.width || 100"
            show-overflow-tooltip
          >
            <template #default="{ row }" >
              <span>{{ row[column.fieldKey] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template #default="scope">
              <el-link type="primary" @click="handleChangePosition(scope.row)" class="mr-10">调换</el-link>
              <el-link type="primary" @click="handleMaterialTableClick(scope.row)">变更明细</el-link>
              <el-link type="primary" @click="handleChuku(scope.row)" v-if="scope.row.amount">直接出库</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />

    <el-dialog
      v-model="batchCreateVisible"
      v-if="batchCreateVisible"
      :close-on-click-modal="false"
      title="批量创建"
      width="50%"
    >
      <div class="local-batch-rule">批量生成规则：[名称]= [前缀] + [号码]；<br/>例如：当prefix=No，startNum=1，endNum=100，numMinSize=3；<br/>将生成100个位置信息[No001,No002,No003...]。</div>
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
        >
          <div class="underlineForm">
            <el-form-item label="上级位置" prop="superId">
              <el-cascader :filterable="true" v-model="formData.superId" class="filter-item" :props="cascaderLoad" :clearable="true" placeholder="输入关键字搜索">
                <template #default="{ node, data }">
                  <span style="display:none">{{ node.isLeaf }}</span>
                  <span>{{ data.name }}</span>
                </template>
              </el-cascader>
            </el-form-item>
            <el-form-item label="前缀" prop="prefix">
              <el-input
                v-model="formData.prefix"
                class="filter-item"
                clearable
              />
            </el-form-item>
            <el-form-item label="开始号码" prop="startNum">
              <el-input
                v-model="formData.startNum"
                class="filter-item"
                clearable
              />
            </el-form-item>
            <el-form-item label="结束号码" prop="endNum">
              <el-input
                v-model="formData.endNum"
                class="filter-item"
                clearable
              />
            </el-form-item>
            <el-form-item label="号码最小位数" prop="numMinSize">
              <el-input
                v-model="formData.numMinSize"
                class="filter-item"
                clearable
              />
            </el-form-item>
          </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="batchCreateVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="handleBatchCreateSubmit"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="historyVisible"
      v-if="historyVisible"
      :close-on-click-modal="false"
      title="变更明细"
      width="700px"
    >
      <el-table
        border
        :data="inOutHistoryData"
        :highlight-current-row="true"
        @header-dragend="handleHistoryHeaderDragend"
      >
      <!-- FieldHistoryTable -->
        <el-table-column
          v-for="(column, index) of historyCloumn"
          :key="column.fieldKey + index"
          :prop="JSON.stringify(column)"
          :label="column.fieldName"
          :min-width="column.width || 100"
          show-overflow-tooltip
        >
          <template #default="{ row }" >
            <span>{{ row[column.fieldKey] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        v-show="inOutHistoryPageVo.total > 0"
        :total="inOutHistoryPageVo.total"
        v-model:currentPage="inOutHistoryPageVo.page"
        :page-size="inOutHistoryPageVo.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </el-dialog>
    <RukuFormComponent
      v-if="exchangeRukuVisible"
      :api="'purchase'"
      from="local"
      :locationId="activeLocalRow.id"
      :purchaseType="purchaseType"
      :materialData="activeMaterialRow"
      @update:visibel="() => exchangeRukuVisible = false"
      @submit="handleExchangeRukuSubmit(formData)"
    />
    <el-dialog
      v-model="chukuVisible"
      v-if="chukuVisible"
      title="出库确认"
      width="500px"
    >
      <el-form
        ref="dataForm"
        :model="chukuFormData"
        :rules="chukuRules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <div class="underlineForm">
          <el-form-item label="数量" prop="paymentMark" class="fullWidth">
            <el-input
              v-model="chukuFormData.num"
              placeholder=" "
              type="number"
            />
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="chukuVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSubmitChuku">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, putUrl } from '@/apis/Dictionary'
import { getListByNo, batchCreate } from '@/apis/location'
import { getTableColumnList, tableSetting } from '@/apis/tool'

import { ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import { FieldMaterialTable } from './FieldMaterialTable'
import { FieldHistoryTable } from './FieldHistoryTable'

import { getPageList } from '@/apis/Form'
import RukuFormComponent from '@/views/purchasManage/purchase/RukuForm.vue'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Inventorylocal',
  components: {
    FormComponent,
    RukuFormComponent
  },
  setup() {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_INVENTORY_LOCAL,
      tableNameMeterial: TableName.TABLE_INVENTORY_LOCAL_MATERIAL,
      tableNameHistory: TableName.TABLE_INVENTORY_LOCAL_HISTORY,
      permissionName: permissionName.INVENTORY_LOCAL,

      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,
      materialCloumn: FieldMaterialTable,
      historyCloumn: FieldHistoryTable,

      pathApi: 'location',
      activeId: 0,
      superId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      deptTop: {
        superId: 0,
        id: 0,
        name: '顶级区域'
      },
      superIdOptions: [],
      maps: new Map(),
      refreshRow: {} as ArrayRowsItem,
      columnData: [],
      batchCreateVisible: false,
      formData: {
        superId: null,
        prefix: null,
        startNum: null,
        endNum: null,
        numMinSize: null
      },
      rules: {
        superId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        startNum: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        endNum: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      selection: [] as any[],
      materialData: [],
      materialPageVo: {
        ...pageVo,
        total: 0,
        locationId: 0
      },
      inOutHistoryData: [],
      inOutHistoryPageVo: {
        ...pageVo,
        total: 0
      },
      exchangeRukuVisible: false,
      activeMaterialRow: {} as ArrayRowsItem,
      selectMaterialRow: {} as ArrayRowsItem,
      purchaseType: 2,
      activeLocalRow: {} as ArrayRowsItem,
      pageSizes,
      historyVisible: false,
      chukuVisible: false,
      chukuFormData: {} as any,
      chukuRules: {
        num: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate(dataMap.deptTop)
            break
          case 'addRow':
            dataMap.handleCreate(val)
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.list = []
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'batchCreate':
            dataMap.formData = {
              superId: null,
              prefix: null,
              startNum: null,
              endNum: null,
              numMinSize: null
            }
            dataMap.batchCreateVisible = true
            break
          case 'batchDelete': {
            if (!dataMap.selection.length) {
              return ElMessage.error('请选择需要删除的数据！')
            }
            const ids = dataMap.selection.map((item: any) => {
              return item.id
            })
            dataMap.handleDelete({ id: ids.join(), superId: 0 })
          }
            break
          case 'rukuError':
            dataMap.purchaseType = 3
            dataMap.exchangeRukuVisible = true
            dataMap.activeLocalRow = val
            break
          // case 'ruku':
          //   dataMap.purchaseType = 1
          //   dataMap.exchangeRukuVisible = true
          //   dataMap.activeLocalRow = val
          //   break
        }
      },
      getList() {
        dataMap.listLoading = true
        getListByNo(0).then((res: any) => {
          dataMap.list = res
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleSelectionChange(value: any) {
        dataMap.selection = value || []
      },
      handleLoadLazy(tree: any, treeNode: any, resolve: any) {
        dataMap.maps.set(tree.id, { tree, treeNode, resolve })
        getListByNo(tree.id).then((res: any) => {
          resolve(res)
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handleCreate(row: any) {
        dataMap.activeId = 0
        dataMap.refreshRow = {
          ...row,
          superId: row.id
        }
        dataMap.loadFormDataSlectOption(row)
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.refreshRow = row
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
                if (field.fieldKey === 'superId') {
                  field.option = [{
                    id: row.id,
                    name: row.name
                  }]
                }
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        dataMap.refreshRow = row
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.handleSubmit()
              ElMessage.success('删除成功!')
            })
          })
      },
      handleSubmit() {
        dataMap.list = []
        dataMap.getList()
      },
      loadFormDataSlectOption(row: any) {
        dataMap.initFormData.forEach((item: any) => {
          item.formList.forEach((k: any) => {
            if (k.fieldKey === 'superId') {
              k.value = row.id
              k.option = [{
                id: row.id,
                name: row.name
              }]
            }
          })
        })
      },
      handleLoadColumn() {
        getTableColumnList(dataMap.TableName).then((res: any) => {
          const _tempArr: any = []
          if (res && res.fields && res.fields.length) {
            res.fields.forEach((item: any) => {
              dataMap.columnAllData.forEach((k: any) => {
                if (k.fieldKey === item.fieldKey) {
                  k.width = item.width
                  _tempArr.push({ ...k, width: item.width || k.width })
                }
              })
            })
            dataMap.columnData = _tempArr
          } else {
            dataMap.columnData = dataMap.columnAllData
          }
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
          dataMap.columnData = dataMap.columnAllData
        })
        getTableColumnList(dataMap.tableNameMeterial).then((res: any) => {
          const _tempArr: any = []
          if (res && res.fields && res.fields.length) {
            res.fields.forEach((item: any) => {
              dataMap.materialCloumn.forEach((k: any) => {
                if (k.fieldKey === item.fieldKey) {
                  k.width = item.width
                  _tempArr.push({ ...k, width: item.width || k.width })
                }
              })
            })
            dataMap.materialCloumn = _tempArr
          }
        })
        getTableColumnList(dataMap.tableNameHistory).then((res: any) => {
          const _tempArr: any = []
          if (res && res.fields && res.fields.length) {
            res.fields.forEach((item: any) => {
              dataMap.historyCloumn.forEach((k: any) => {
                if (k.fieldKey === item.fieldKey) {
                  k.width = item.width
                  _tempArr.push({ ...k, width: item.width || k.width })
                }
              })
            })
            dataMap.historyCloumn = _tempArr
          }
        })
      },
      async handleBatchCreateSubmit() {
        const { numMinSize, startNum, endNum, superId, prefix } = dataMap.formData
        const temp = {
          endNum: Number(endNum),
          startNum: Number(startNum),
          numMinSize: Number(numMinSize),
          superId,
          prefix
        }
        console.log(temp, 'dataMap.formData')
        ElMessage.success('批量创建成功!')
        dataMap.batchCreateVisible = false
        await batchCreate(temp)
        dataMap.getList()
      },
      cascaderLoad: {
        lazy: true,
        checkStrictly: true,
        label: 'name',
        value: 'id',
        emitPath: false,
        lazyLoad(node: any, resolve: any) {
          const { level } = node
          const id = level === 0 ? level : node.data.id
          if (level === 0) {
            resolve([dataMap.deptTop])
          } else {
            getListByNo(id).then((res: any) => {
              const nodes = res.map((k: any) => {
                return {
                  ...k,
                  leaf: !k.hasChildren
                }
              })
              resolve(nodes)
            })
          }
        }
      },
      handlePositonTableClick(row: any) {
        dataMap.loadMaterialData(row)
      },
      loadMaterialData(row: any) {
        dataMap.materialPageVo.locationId = row.id
        getPageList(`location/${row.id}/action/storages`, dataMap.materialPageVo).then((res: any) => {
          dataMap.materialPageVo.total = res.total
          dataMap.materialData = res.data.map((item: any) => {
            return {
              amount: item.amount,
              ...item.material,
              locationId: row.id
            }
          })
        })
      },
      handleMaterialTableClick(row: any) {
        dataMap.selectMaterialRow = row
        dataMap.loadInOutHistoryDataData()
      },
      handleChuku(row: any) {
        dataMap.chukuVisible = true
        dataMap.chukuFormData = {
          ...row,
          num: 0
        }
      },
      async handleSubmitChuku() {
        const { locationId, id, num } = dataMap.chukuFormData
        if (!num) {
          ElMessage.error('出库数量必须大于0!')
        }
        await putUrl(`storage/directOutbound/${locationId}/${id}/${num}`)
        ElMessage.success('出库成功!')
        dataMap.chukuVisible = false
        getPageList(`location/${locationId}/action/storages`, dataMap.materialPageVo).then((res: any) => {
          dataMap.materialPageVo.total = res.total
          dataMap.materialData = res.data.map((item: any) => {
            return {
              amount: item.amount,
              ...item.material,
              locationId
            }
          })
        })
      },
      handleChangePosition(row: any) {
        dataMap.purchaseType = 2
        dataMap.exchangeRukuVisible = true
        dataMap.activeMaterialRow = { ...row, oldLocationId: dataMap.materialPageVo.locationId }
      },
      loadInOutHistoryDataData() {
        const { page, size } = dataMap.inOutHistoryPageVo
        getPageList(`storage/actions/histories/${dataMap.materialPageVo.locationId}/${dataMap.selectMaterialRow.id}`, { page, size }).then((res: any) => {
          dataMap.inOutHistoryData = res.data
          dataMap.inOutHistoryPageVo.total = res.total
          dataMap.historyVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.inOutHistoryPageVo.page = page
        dataMap.loadInOutHistoryDataData()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      handleExchangeRukuSubmit() {
        dataMap.loadMaterialData(dataMap.activeMaterialRow)
      },
      handleHeaderDragend(newWidth: any, oldWidth: any, column: any) {
        console.log(oldWidth)
        const targetFieldKey = JSON.parse(column.property)?.fieldKey
        const tempData = dataMap.columnData.map((item: any) => {
          const width = item.fieldKey === targetFieldKey ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
        tableSetting({ tableName: dataMap.TableName, fields: tempData })
        dataMap.columnAllData = dataMap.columnAllData.map((item: any) => {
          const width = item.fieldKey === targetFieldKey ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
      },
      handleMaterialHeaderDragend(newWidth: any, oldWidth: any, column: any) {
        const targetFieldKey = JSON.parse(column.property)?.fieldKey
        dataMap.materialCloumn = dataMap.materialCloumn.map((item: any) => {
          const width = item.fieldKey === targetFieldKey ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
        tableSetting({ tableName: dataMap.tableNameMeterial, fields: dataMap.materialCloumn })
      },
      handleHistoryHeaderDragend(newWidth: any, oldWidth: any, column: any) {
        const targetFieldKey = JSON.parse(column.property)?.fieldKey
        dataMap.historyCloumn = dataMap.historyCloumn.map((item: any) => {
          const width = item.fieldKey === targetFieldKey ? newWidth : item.width
          return {
            ...item,
            width
          }
        })
        tableSetting({ tableName: dataMap.tableNameHistory, fields: dataMap.historyCloumn })
      }
    })

    onMounted(() => {
      dataMap.handleLoadColumn()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">
.local-batch-rule{
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 10px;
  border-radius: 8px;
  background: rgba(255, 151, 39,0.1);
  margin-bottom: 10px;
  line-height: 24px
}
.icon-tubiao-40{
  color:#E74228;
}
</style>
